module.exports = "pegasus_template/assets/theme6/l_d.png";